import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Observable, BehaviorSubject, timer, of } from 'rxjs';
import { switchMap, tap, distinctUntilChanged } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@UntilDestroy()
@Component({
    selector: 'nova-am-submittal-status-update-cancel-button',
    templateUrl: 'am-submittal-status-update-cancel-button.component.html',
    styles: [],
    standalone: true,
    imports: [MatButtonModule, AsyncPipe]
})
export class AmSubmittalStatusUpdateCancelButtonComponent implements OnInit {
    @Input() label = 'Cancel';
    @Input() disableDuration = 5000;
    @Output() clicked = new EventEmitter<void>();

    private readonly disableButton$ = new BehaviorSubject<boolean>(false);
    isDisabled$: Observable<boolean> = this.disableButton$.asObservable();

    ngOnInit() {
        this.disableButton$
            .pipe(
                distinctUntilChanged(),
                switchMap((disable) => {
                    if (disable) {
                        return timer(this.disableDuration).pipe(tap(() => this.disableButton$.next(false)));
                    }

                    return of(false);
                }),
                untilDestroyed(this)
            )
            .subscribe();
    }

    onClick() {
        this.clicked.emit();
    }

    disable() {
        this.disableButton$.next(true);
    }

    enable() {
        this.disableButton$.next(false);
    }
}
